module.exports = __webpack_public_path__ + "static/media/performingarts.dd342386.jpg";